import { Typography } from "antd";
import { useIntl } from "react-intl";
import type { PaginationConfig } from "~components/DataTable/types/paginationConfig.ts";

const { Text } = Typography;
export const PaginationTotal = ({ paginationConfig }: { paginationConfig?: PaginationConfig }) => {
  const { formatMessage } = useIntl();
  if (!paginationConfig || !paginationConfig.total) return null;
  const from = (paginationConfig.currentPage - 1) * paginationConfig.pageSize + 1;
  const to = paginationConfig.currentPage * paginationConfig.pageSize;

  return (
    <div>
      <Text strong>
        {`${formatMessage({ id: "data.table.pagination.showing" })} ${from} - ${to > paginationConfig.total ? paginationConfig.total : to} ${formatMessage({ id: "data.table.pagination.of" })} ${paginationConfig.total}`}
      </Text>
    </div>
  );
};
